import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ChevronDownIcon } from "../../icons/inputIcons/ChevronDownIcon";
import { themeColor } from "ui/theme";
import { HelperText } from "../helperText/HelperText";

const Counter = ({
  icon,
  label,
  minToCount = 1,
  maxToCount = 20,
  value,
  onChange,
  errorText,
  isError,
}) => {
  const [count, setCount] = useState(value ?? 1);

  useEffect(() => {
    onChange?.(count);
  }, [count]);

  return (
    <Container>
      {label ? <HelperText>{label}</HelperText> : null}

      <CounterContainer>
        {true && (
          <InputIcon isError={false} hasValue={true} position="left">
            {icon}
          </InputIcon>
        )}

        <Value>{count}</Value>

        <ArrowControls>
          <ButtonCounter
            isVisible={count < maxToCount}
            onClick={() => setCount((prev) => Math.min(prev + 1, maxToCount))}
          >
            <ChevronUpIcon />
          </ButtonCounter>

          <ButtonCounter
            isVisible={count > minToCount}
            onClick={() => setCount((prev) => Math.max(minToCount, prev - 1))}
          >
            <ChevronDownIcon />
          </ButtonCounter>
        </ArrowControls>
      </CounterContainer>

      {isError ? (
        <HelperText color="pink" size="small">
          {errorText}
        </HelperText>
      ) : null}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: grid;
  gap: 1rem;
`;

const CounterContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: fit-content;
  background-color: #fff;
`;

const ButtonCounter = styled.button`
  border: 0px;
  background-color: ${themeColor("transparent")}; 
  cursor:  ${({ isVisible }) => (isVisible ? "pointer" : "default")};
  padding: 2px;  
  visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
`;

const InputIcon = styled.div`
  display: flex;
  align-items: center;
  color: ${({ isError, hasValue }) =>
    isError
      ? themeColor("pink")
      : hasValue
        ? themeColor("blue")
        : themeColor("border")};
  margin-right: ${({ position }) => (position === "left" ? "8px" : "0")};
`;

const ChevronUpIcon = styled(ChevronDownIcon)`
  transform: rotate(180deg);
`;

const Value = styled.span`
  min-width: 20px;
  text-align: center;
  font-size: 16px;
  margin: 0 8px;
`;

const ArrowControls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  svg {
    color: #0f172a;
    font-size: 10px;
  }
`;

export default Counter;
